/**
 * Normalize package features from array or legacy map format.
 */
export function normalizePackageFeatures(features) {
  if (!features) return [];

  if (Array.isArray(features)) {
    return features.filter(Boolean);
  }

  if (typeof features === 'object') {
    return Object.entries(features)
      .filter(([, enabled]) => enabled)
      .map(([key]) =>
        key
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
  }

  return [];
}

export function getResourceCounts(company) {
  const counts = company?.resourceCounts || {};
  return {
    employees:
      counts.employees ??
      counts.employeesCount ??
      company?.employeesCount ??
      0,
    appointments:
      counts.appointments ??
      counts.appointmentsCount ??
      company?.appointmentsCount ??
      0,
  };
}
